<template>
  <ValidationObserver v-slot="{ handleSubmit, invalid ,reset}" ref="observer">
    <artisio-modal :visible="modal.show" :data="model" :title="computedTitle" @show="onShow" size="sm"
                   @hidden="onHidden" @ok.prevent="handleSubmit(onSubmit)" :show-confirmation="showConfirmation"
                   :ok-title="$t('Submit')" :is-loading="loading" scrollable>
      <div class="row">
        <div class="col-md-12">
          <currency-input-widget :model="model" attribute="amount" :currency="currency"/>
        </div>
        <div class="col-md-12">
          <sale-select-input-widget :model="model" attribute="auction_uuid" value-field="uuid" @select="onSaleSelect"/>
        </div>
      </div>
    </artisio-modal>
  </ValidationObserver>
</template>

<script>
  import ArtisioModal from "../../../../core/components/artisio-modal/ArtisioModal";
  import InputWidget from "../../../../core/components/input-widget/InputWidget";
  import {createNamespacedHelpers} from "vuex";
  import CurrencyInputWidget from "../../../../core/widgets/CurrencyInputWidget";
  import CustomerReservationModel from "./CustomerReservation.model";
  import SaleSelectInputWidget from "../../../../core/widgets/SaleSelectInputWidget";

  const {mapState, mapActions} = createNamespacedHelpers('customer/customerView');

  export default {
    name: "CustomerReservationModal",
    components: {SaleSelectInputWidget, CurrencyInputWidget, InputWidget, ArtisioModal},
    data() {
      return {
        loading: false,
        showConfirmation: true,
        model: new CustomerReservationModel(),
        selectedSale: null
      }
    },
    computed: {
      ...mapState({
        customer: state => state.customer,
        modal: state => state.balanceData.reservationModal,
        editObject: state => state.balanceData.reservationModal.object,
      }),
      computedTitle() {
        return this.model.uuid ? this.$i18n.t(`Update Reservation`) : this.$i18n.t(`Add New Reservation`);
      },
      currency() {
        if (this.model.uuid) {
          return this.model.currency.symbol;
        }
        return this.selectedSale ? this.selectedSale.currency.symbol : null;
      }
    },
    watch: {
      editObject() {
        if (this.editObject && (this.editObject.uuid || this.editObject.type)) {
          this.model = new CustomerReservationModel(this.editObject);
        }
      }
    },
    methods: {
      ...mapActions(['hideCustomerReservationModal', 'createCustomerReservation', 'updateCustomerReservation']),
      onShow() {
        this.showConfirmation = true
      },
      onHidden() {
        this.model = new CustomerReservationModel();
        this.hideCustomerReservationModal();
      },
      onSaleSelect(sale) {
        this.selectedSale = sale;
      },
      async onSubmit() {
        let response;
        this.loading = true;
        this.model.customer_uuid = this.customer.uuid;
        if (!this.model.uuid) {
          response = await this.createCustomerReservation(this.model);
        } else {
          response = await this.updateCustomerReservation(this.model);
        }
        this.loading = false;

        if (response.success) {
          this.showConfirmation = false;
          this.hideCustomerReservationModal();
          if (!this.model.uuid) {
            this.$toast('success', this.$t('Reservation was successfully created'));
          } else {
            this.$toast('success', this.$t('Reservation was successfully updated'));
          }
        } else {
          if (response.toastError) {
            this.$errorDialog(response.toastError);
          } else {
            this.model.setMultipleErrors(response.body);
          }
        }
      },
    }
  }
</script>

<style scoped>

</style>
